import { toPublicURL } from '@plone/volto/helpers/Url/Url';
import { useRestaurantSettings } from '../../hooks/useRestaurantSettings';
import { formatInternationalPhone } from '../../helpers/phone';
import { openingHoursSpecification } from '../../helpers/hours';
import { publicUrl } from '../../helpers/shareMeta';
import JsonLd from './JsonLd';

// Structured data of the restaurant, on every page. The opening hours come
// from the restaurant settings, which read the Hours block of the home page.
const RestaurantJsonLd = () => {
  const settings = useRestaurantSettings();

  const sameAs = [settings.facebook_url, settings.instagram_url].filter(
    Boolean,
  );
  const openingHours = openingHoursSpecification(settings.opening_hours);

  const data: Record<string, any> = {
    '@context': 'https://schema.org',
    '@type': 'Restaurant',
    name: 'À Ciel Ouvert',
    servesCuisine: 'French',
    priceRange: '€€',
    url: toPublicURL('/'),
    image: settings.default_share_image
      ? publicUrl(settings.default_share_image)
      : undefined,
    telephone: formatInternationalPhone(settings.phone_primary) || undefined,
    email: settings.email || undefined,
    address: {
      '@type': 'PostalAddress',
      streetAddress: settings.address_line1,
      postalCode: settings.postal_code,
      addressLocality: settings.city,
      addressCountry: 'BE',
    },
    geo:
      settings.latitude && settings.longitude
        ? {
            '@type': 'GeoCoordinates',
            latitude: settings.latitude,
            longitude: settings.longitude,
          }
        : undefined,
    hasMap: settings.maps_url || undefined,
    acceptsReservations: true,
    sameAs: sameAs.length > 0 ? sameAs : undefined,
    openingHoursSpecification:
      openingHours.length > 0 ? openingHours : undefined,
  };

  return <JsonLd data={data} id="restaurant" />;
};

export default RestaurantJsonLd;
